"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _templateObject = _taggedTemplateLiteral(["\n                  ", ";\n              "], ["\n                  ", ";\n              "]),
    _templateObject2 = _taggedTemplateLiteral(["\n                  @media (min-width: ", "px) {\n                      ", ";\n                  }\n              "], ["\n                  @media (min-width: ", "px) {\n                      ", ";\n                  }\n              "]),
    _templateObject3 = _taggedTemplateLiteral(["\n    width: 100%;\n    padding: 0\n        ", "em;\n\n    /*responsive*/\n    ", ";\n\n    /* Centered */\n    ", ";\n"], ["\n    width: 100%;\n    padding: 0\n        ", "em;\n\n    /*responsive*/\n    ", ";\n\n    /* Centered */\n    ", ";\n"]),
    _templateObject4 = _taggedTemplateLiteral(["width: ", "%;"], ["width: ", "%;"]),
    _templateObject5 = _taggedTemplateLiteral(["\n                  margin: auto;\n              "], ["\n                  margin: auto;\n              "]),
    _templateObject6 = _taggedTemplateLiteral(["\n                  float: left;\n              "], ["\n                  float: left;\n              "]);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require("styled-components");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _theme = require("../theme");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

// Width to percentage
var widthPercentage = function widthPercentage(width) {
    return Math.min(Math.floor(width), 12) / 12 * 100;
};

// Iterate through the breakpoints and create a media template
// If width prop is defied, then use pseudo js breakpoint instead
var media = Object.keys(_theme.breakpoints).reduce(function (acc, label) {
    acc[label] = function () {
        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return function (props) {
            return props.parentWidth ? parseInt(props.parentWidth) > _theme.breakpoints[label] && (0, _styledComponents.css)(_templateObject, _styledComponents.css.apply(undefined, args)) : (0, _styledComponents.css)(_templateObject2, _theme.breakpoints[label], _styledComponents.css.apply(undefined, args));
        };
    };

    return acc;
}, {});

// The Column - loop through all breakpoints and insert into media query
var StyledColumn = _styledComponents2.default.div(_templateObject3, function (props) {
    return props.collapse ? 0 : props.theme.column.padding / 2;
}, function (props) {
    return Object.keys(_theme.breakpoints).map(function (key) {
        return props[key] && media[key](_templateObject4, widthPercentage(props[key]));
    });
}, function (props) {
    return props.centered ? (0, _styledComponents.css)(_templateObject5) : (0, _styledComponents.css)(_templateObject6);
});

var Column = function (_React$Component) {
    _inherits(Column, _React$Component);

    function Column() {
        _classCallCheck(this, Column);

        return _possibleConstructorReturn(this, (Column.__proto__ || Object.getPrototypeOf(Column)).apply(this, arguments));
    }

    _createClass(Column, [{
        key: "render",
        value: function render() {
            var _props = this.props,
                children = _props.children,
                rest = _objectWithoutProperties(_props, ["children"]);
            //console.log(rest);


            return _react2.default.createElement(
                StyledColumn,
                rest,
                children
            );
        }
    }]);

    return Column;
}(_react2.default.Component);

Column.displayName = "Column";

Column.propTypes = {
    small: _propTypes2.default.number,
    medium: _propTypes2.default.number,
    large: _propTypes2.default.number,
    xlarge: _propTypes2.default.number,
    centered: _propTypes2.default.bool
};

Column.defaultProps = {
    centered: false
};

exports.default = Column;


//////////////////
// WEBPACK FOOTER
// ./~/rla-components/dist/components/column.js
// module id = 452
// module chunks = 95715928098905 168707334958949